import { render } from "./NavigationView.vue?vue&type=template&id=479f5318&scoped=true"
import script from "./NavigationView.vue?vue&type=script&lang=js"
export * from "./NavigationView.vue?vue&type=script&lang=js"

import "./NavigationView.vue?vue&type=style&index=0&id=479f5318&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-479f5318"],['__file',"src/components/navigation/NavigationView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "479f5318"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('479f5318', __exports__)) {
    api.reload('479f5318', __exports__)
  }
  
  module.hot.accept("./NavigationView.vue?vue&type=template&id=479f5318&scoped=true", () => {
    api.rerender('479f5318', render)
  })

}


export default __exports__